import React from 'react';

import Col from 'react-bootstrap/Col';

import { Color } from '../../Enum/Color';
import ResultIcon from './ResultIcon';
import { Scopable } from '../../Interface/Scopable';

interface Props {
    rules: Scopable[];
    color: Color;
}

const ScopeResult: React.FC<Props> = Props => {
    const { rules, color } = Props;

    let amountApplicableRules: number;
    if (color === Color.Grey) {
        amountApplicableRules = rules.filter(rule => null === rule.resultaat).length;
    } else {
        amountApplicableRules = rules.filter(rule => rule.resultaat === color).length;
    }

    return (
        <Col className="summary">
            <div className="scope-result">
                <span className={amountApplicableRules === 0 ? 'non-active' : ''}>
                    {amountApplicableRules} / {rules.length}
                </span>
                <span>
                    <ResultIcon active={amountApplicableRules > 0} color={color} />
                </span>
            </div>
        </Col>
    );
};

export default ScopeResult;
